import { gql } from '@apollo/client'

import { WebhookSubscriptionDetailsFragment } from 'graphql/fragments'

export const GET_PAGED_WEBHOOK_SUBSCRIPTIONS = gql`
  query GetPagedWebhookSubscriptions(
    $customerId: Long!
    $isEnabled: Boolean
    $after: String
    $before: String
    $first: Int
    $last: Int
    $order: [WebhookSubscriptionDtoSortInput!]
  ) {
    pagedWebhookSubscriptions(
      customerId: $customerId
      isEnabled: $isEnabled
      after: $after
      before: $before
      first: $first
      last: $last
      order: $order
    ) {
      edges {
        node {
          ...WebhookSubscriptionDetails
        }
      }
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasPreviousPage
        hasNextPage
      }
    }
  }

  ${WebhookSubscriptionDetailsFragment}
`

export const GET_PAGED_WEBHOOK_DELIVERIES = gql`
  query GetPagedWebhookDeliveries(
    $webhookSubscriptionId: Long!
    $after: String
    $before: String
    $first: Int
    $last: Int
    $order: [WebhookDeliveryDtoSortInput!]
  ) {
    pagedWebhookDeliveries(
      webhookSubscriptionId: $webhookSubscriptionId
      after: $after
      before: $before
      first: $first
      last: $last
      order: $order
    ) {
      edges {
        node {
          id
          eventId
          eventType
          status
          attemptCount
          createdAt
          nextAttemptAt
          lastAttemptAt
          deliveredAt
          lastStatusCode
          lastError
        }
      }
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasPreviousPage
        hasNextPage
      }
    }
  }
`
